import React from 'react'
import { DocumentCategory } from 'share/domain/document'
import {
  setSelectedDocumentCategory,
  setSelectedDocumentCategoryId
} from 'reducers/document/documentProcessingSlice'
import { useAppDispatch } from 'hooks/store'
import { useHistory } from 'react-router-dom'
import './styles.scss'

interface Props {
  folders: DocumentCategory[]
}

const getStatus = (status: string, withIcon = true): string => {
  switch (status.toLowerCase()) {
    case 'new':
      return `${withIcon && 'mdi  mdi-check-circle-outline'} gray`
    case 'pending':
      return `${withIcon && 'mdi mdi-clock-outline'} yellow`
    case 'rejected':
      return `${withIcon && 'mdi mdi-alert-rhombus-outline'} red`
    case 'accepted':
      return `${withIcon && 'mdi mdi-check-circle-outline'} green`
    case 'complete':
      return `${withIcon && 'mdi mdi-check-circle-outline'} green`
    default:
      return ''
  }
}

const DocumentFolderList = (props: Props): JSX.Element => {
  const dispatch = useAppDispatch()
  const history = useHistory()
  return (
    <div>
      <ul data-testid='submit-docs-list' className='docs-list mb-0 mt-0'>
        {props.folders.length &&
          props.folders.map((folder: DocumentCategory) => (
            <li
              data-testid='submit-docs-list-item'
              key={folder.id}
              onClick={() => {
                dispatch(setSelectedDocumentCategory(folder))

                dispatch(setSelectedDocumentCategoryId(folder.id))

                history.push('/dashboard/documents/subCategory')
              }}
            >
              <div className='ui-docs-item'>
                <div className='doc-status'>
                  <span className={getStatus(folder.status)}></span>
                  <span>{folder.name}</span>
                </div>
                <div className='mdi mdi-chevron-right'></div>
              </div>
            </li>
          ))}
      </ul>
    </div>
  )
}

export default DocumentFolderList
